<div
	*ngIf="items.length"
	class="tw-mt-1 tw-mr-1 tw-min-w-0 tw-max-w-full tw-overflow-hidden sm:tw-mr-2 lg:tw-mr-3"
	role="group"
	[attr.aria-label]="title"
>
	<div class="tw-grid tw-grid-cols-5 tw-gap-x-1 tw-gap-y-0.5 sm:tw-gap-x-1.5 sm:tw-gap-y-1 tw-w-full tw-min-w-0 tw-max-w-full tw-overflow-hidden">
		<div
			*ngFor="let ms of items; let i = index"
			class="tw-inline-flex tw-items-center tw-gap-0.5 sm:tw-gap-1 tw-min-w-0 tw-max-w-full tw-overflow-hidden tw-px-1 sm:tw-px-1.5 lg:tw-px-2 tw-py-0.5 sm:tw-py-1 tw-rounded-lg tw-text-[10px] sm:tw-text-[11px] tw-font-semibold tw-leading-none tw-border tw-border-solid tw-border-transparent tw-transition-colors tw-duration-200"
			[style.backgroundColor]="chipColors(ms).bg"
			[style.borderColor]="chipColors(ms).border"
			[title]="ms.milestone.label"
		>
			<span
				class="tw-inline-flex tw-shrink-0 tw-leading-none"
				[class.tw-grayscale]="ms.status !== 'achieved'"
				[style.color]="chipColors(ms).star"
				aria-hidden="true"
			>
				<app-para-milestone-icon [tier]="iconTier(ms, i)" svgClass="tw-h-4 tw-w-4"></app-para-milestone-icon>
			</span>

			<span
				class="tw-min-w-0 tw-flex-1 tw-truncate"
				[style.color]="chipColors(ms).label"
			>{{ ms.milestone.label }}</span>
		</div>
	</div>
</div>
